module.exports = __webpack_public_path__ + "img/icon_kinderwunsch.4d5b406f.svg";